<template>
  <component :is="pageComp" v-if="pageComp" />
  <div v-else class="proto-miss">
    <p>该方案详情页尚未接入（{{ tabKey }}/{{ slug }}）</p>
    <el-button type="primary" @click="$router.push('/portal/solutions')">返回解决方案</el-button>
  </div>
</template>

<script lang="ts" setup>
import { defineAsyncComponent, type Component } from 'vue'

defineOptions({ name: 'PortalSolutionPrototypeHost' })

const route = useRoute()
const tabKey = computed(() => String(route.params.tabKey || ''))
const slug = computed(() => String(route.params.slug || ''))

/** tabKey/slug → 原型 Vue 页（无自带顶底；壳用 PortalNavbar + PortalFooter） */
const PAGE_MAP: Record<string, () => Promise<Component>> = {
  'ecommerce/ecom-b2b2c': () => import('./EcomB2b2cPage.vue'),
  'ecommerce/ecom-b2b': () => import('./EcomB2bPage.vue'),
  'ecommerce/ecom-b2c': () => import('./EcomB2cPage.vue'),
  'ecommerce/ecom-c2c': () => import('./EcomC2cPage.vue'),
  'ecommerce/ecom-o2o': () => import('./EcomO2oPage.vue'),
  'ecommerce/ecom-yiyuan': () => import('./EcomYiyuanPage.vue'),
  'cross-border/xb-daigou': () => import('./XbDaigouPage.vue'),
  'cross-border/xb-cross': () => import('./XbCrossPage.vue'),
  'industry-suite/is-appliance': () => import('./IsAppliancePage.vue'),
  'industry-suite/is-estate': () => import('./IsEstatePage.vue'),
  'industry-suite/is-apparel': () => import('./IsApparelPage.vue'),
  'industry-suite/is-home': () => import('./IsHomePage.vue'),
  'industry-suite/is-finance': () => import('./IsFinancePage.vue'),
  'industry-suite/is-hotel': () => import('./IsHotelPage.vue'),
  'industry-suite/is-beauty': () => import('./IsBeautyPage.vue'),
  'industry-suite/is-mother': () => import('./IsMotherPage.vue'),
  'industry-suite/is-retail': () => import('./IsRetailPage.vue'),
  'industry-suite/is-jewelry': () => import('./IsJewelryPage.vue'),
  'smart-build/sb-daijia': () => import('./SbDaijiaPage.vue'),
  'smart-build/sb-travel': () => import('./SbTravelPage.vue'),
  'smart-build/sb-medical': () => import('./SbMedicalPage.vue'),
  'smart-build/sb-elderly': () => import('./SbElderlyPage.vue'),
  'smart-build/sb-rural': () => import('./SbRuralPage.vue'),
  'smart-build/sb-property': () => import('./SbPropertyPage.vue'),
  'smart-build/sb-pharma': () => import('./SbPharmaPage.vue'),
  'smart-build/sb-training': () => import('./SbTrainingPage.vue'),
  'smart-build/sb-agri': () => import('./SbAgriPage.vue'),
  'smart-build/sb-catering': () => import('./SbCateringPage.vue'),
  'smart-build/sb-estate': () => import('./SbEstatePage.vue'),
  'smart-build/sb-ads': () => import('./SbAdsPage.vue')
}

const pageComp = computed(() => {
  const key = `${tabKey.value}/${slug.value}`
  const loader = PAGE_MAP[key]
  return loader ? defineAsyncComponent(loader) : null
})
</script>

<style scoped>
.proto-miss {
  min-height: 48vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  color: #64748b;
}
</style>
